import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/matches/[team]/(fixtures-results-table)/fixturesResultsTableLayout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/templates/matches/matches-header/matchesHeader.component.tsx");
